import { useEffect, useState } from "react";
import {
    ArticleCardDisplayConfig,
    ArticleCardDisplayConfigDefaultsToOptionals,
    CustomerTier,
    InternalDisplayConfig
} from "shared/src/types/ArticleCardProps";

const defaultsToOptionalDisplayConfigParts: ArticleCardDisplayConfigDefaultsToOptionals = {
    addToListIsDisabled: (isLoggedIn: boolean, isReplacementSearch: boolean, nonExistentBundle: boolean) =>
        !isLoggedIn || isReplacementSearch || nonExistentBundle,
    addToListIsShown: (isLoggedIn: boolean, customerTier: CustomerTier | null | undefined) =>
        isLoggedIn && !(customerTier === "1" || customerTier === "2"),
    maxPromotionLabelsShown: 2
};

function mergeDisplayConfigAndDefaults(displayConfig: ArticleCardDisplayConfig): InternalDisplayConfig {
    const defaults = {
        ...defaultsToOptionalDisplayConfigParts
    };
    return Object.assign(defaults, displayConfig);
}

export function useDisplayConfig(displayConfig: ArticleCardDisplayConfig) {
    const [internalDisplayConfig, setInternalDisplayConfig] = useState(mergeDisplayConfigAndDefaults(displayConfig));

    useEffect(() => {
        setInternalDisplayConfig(mergeDisplayConfigAndDefaults(displayConfig));
    }, [displayConfig]);

    return {
        internalDisplayConfig
    };
}
